import { IconTextCtaCard } from "@repo/ui/components/common/cms";
import type { IconTextCtaCard as IconTextCtaCardType } from "@repo/ui/types/cms/common";

type TravelInfoListProps = {
  title?: string;
  items?: IconTextCtaCardType[];
  testId?: string;
};

export const TravelInfoList = ({ title, items, testId }: TravelInfoListProps) => (
  <div data-testid={testId ? testId : "travel-info-list-section"}>
    <h4 className="text-brand-blue mb-3 text-base font-semibold">{title}</h4>
    <ul className="text-gray space-y-2 text-sm">
      {items?.map((item) => (
        <IconTextCtaCard key={item.title} item={item} className="cursor-pointer" />
      ))}
    </ul>
  </div>
);
